<template>
  <div class="container">
    <div class="canvas-background" id="canvas-background"></div>
    <admin-header></admin-header>
    <router-view />
    <admin-footer></admin-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import AdminHeader from "@/components/AdminHeader";
import AdminFooter from "@/components/AdminFooter";

export default {
  name: "Home",
  components: {
    AdminHeader,
    AdminFooter,
  },
  mounted() {
    const pathArr = ["privacy-policy", "use-agreement", "privacy-agreement", "shop"];
    const isHave = pathArr.some((x) => this.$route.path.includes(x));
    if (!isHave) {
      this.initBackground();
      window.onresize = () => {
        this.initBackground();
      };
    }
  },
  methods: {
    initBackground() {
      (function () {
        function LogBackground(opt) {
          this.init(opt);
        }
        LogBackground.prototype.init = function (opt) {
          const self = this;
          self._initDom(opt);
          self.canvas.width = this.options.canvasWidth;
          self.canvas.height = this.options.canvasHeight;
          self._initCir(self.context);
          self.render();
        };
        LogBackground.prototype._initDom = function (opt) {
          this.options = {
            canvasContainerID: "canvas-container",
            canvasOpacity: 0.8,
            circleNum: 40,
            circleColor: "rgba(180,180,180,1)",
            lineColor: "rgba(180,180,180,1)",
            circleMovemaxX: 2,
            circleMoveminX: -2,
            circleMovemaxY: 2,
            circleMoveminY: -2,
            canvasWidth: document.documentElement.clientWidth,
            canvasHeight: document.documentElement.clientHeight,
          };
          if (opt) {
            for (const key in opt) {
              if (Object.prototype.hasOwnProperty.call(opt, key)) {
                this.options[key] = opt[key];
              }
            }
          }
          const canvasEle = document.createElement("canvas");
          const canvasContainer = document.getElementById(
            this.options.canvasContainerID
          );
          canvasContainer.innerHTML = "";
          if (this.timer) {
            clearTimeout(this.timer);
          }
          canvasContainer.appendChild(canvasEle);
          canvasEle.style.cssText =
            "position:absolute;left:0;top:0;background:#0E50B1;";
          canvasEle.style.opacity = this.options.canvasOpacity;
          this.canvas = canvasEle;
          this.drawMaxWidth = this.options.canvasWidth + 30;
          this.drawMinWidth = -30;
          this.drawMaxHeight = this.options.canvasHeight + 30;
          this.drawMinHeight = -30;
          this.context = this.canvas.getContext("2d");
          this.circleArr = [];
          this.moveArr = [];
        };
        LogBackground.prototype.random = function (max, _min) {
          const minNum = arguments[1] || 0;
          return Math.floor(Math.random() * (max - minNum + 1) + minNum);
        };
        LogBackground.prototype._initCir = function (context) {
          const self = this;
          for (let i = 0; i < self.options.circleNum; i++) {
            const x = self.random(self.drawMaxWidth, self.drawMinWidth);
            const y = self.random(self.drawMaxHeight, self.drawMinHeight);
            const r = self.random(10);
            const newCircle = self.drawCircle(context, x, y, r);
            self.circleArr.push(newCircle);
            const move = {
              x:
                Math.random() *
                  (self.options.circleMovemaxX - self.options.circleMoveminX) +
                self.options.circleMoveminX,
              y:
                Math.random() *
                  (self.options.circleMovemaxY - self.options.circleMoveminY) +
                self.options.circleMoveminY,
            };
            self.moveArr.push(move);
          }
        };
        LogBackground.prototype._initLine = function (
          ctx,
          bx,
          by,
          cx,
          cy,
          opacity
        ) {
          const self = this;
          function Line(beginX, beginY, closeX, closeY) {
            this.beginX = beginX;
            this.beginY = beginY;
            this.closeX = closeX;
            this.closeY = closeY;
          }
          const line = new Line(bx, by, cx, cy);
          ctx.beginPath();
          ctx.moveTo(line.beginX, line.beginY);
          ctx.lineTo(line.closeX, line.closeY);
          ctx.stroke();
          const colorArr = self.options.lineColor.split(",");
          ctx.strokeStyle =
            colorArr[0] +
            "," +
            colorArr[1] +
            "," +
            colorArr[2] +
            "," +
            opacity +
            ")";
          ctx.closePath();
        };
        LogBackground.prototype.render = function () {
          const self = this;
          self.context.clearRect(
            0,
            0,
            self.options.canvasWidth,
            self.options.canvasHeight
          );
          for (let i = 0; i < self.options.circleNum; i++) {
            const changeCircle = self.circleArr[i];
            changeCircle.centerX += self.moveArr[i].x;
            changeCircle.centerY += self.moveArr[i].y;
            self.drawCircle(
              self.context,
              changeCircle.centerX,
              changeCircle.centerY,
              changeCircle.radius
            );
            if (changeCircle.centerX < self.drawMinWidth) {
              changeCircle.centerX = self.drawMaxWidth;
              changeCircle.centerY = self.random(
                self.drawMaxHeight,
                self.drawMinHeight
              );
            } else if (changeCircle.centerX > self.drawMaxWidth) {
              changeCircle.centerX = self.drawMinWidth;
              changeCircle.centerY = self.random(
                self.drawMaxHeight,
                self.drawMinHeight
              );
            } else if (changeCircle.centerY < self.drawMinHeight) {
              changeCircle.centerY = self.random(
                self.drawMaxWidth,
                self.drawMinWidth
              );
              changeCircle.centerY = self.drawMaxHeight;
            } else if (changeCircle.centerY > self.drawMaxHeight) {
              changeCircle.centerY = self.random(
                self.drawMaxWidth,
                self.drawMinWidth
              );
              changeCircle.centerY = self.drawMinWidth;
            }
          }
          for (let j = 0; j < self.options.circleNum; j++) {
            for (let k = 0; k < self.options.circleNum; k++) {
              const bx = self.circleArr[j].centerX;
              const by = self.circleArr[j].centerY;
              const cx = self.circleArr[k].centerX;
              const cy = self.circleArr[k].centerY;
              const dis = Math.sqrt(
                Math.abs(cx - bx) * Math.abs(cx - bx) +
                  Math.abs(by - cy) * Math.abs(by - cy)
              );
              if (
                dis < 0.3 * this.options.canvasWidth ||
                dis > this.options.canvasWidth * 1.2
              ) {
                let lineOpacity = 1;
                lineOpacity = lineOpacity > 0.3 ? 0.3 : lineOpacity;
                self._initLine(self.context, bx, by, cx, cy, lineOpacity);
              }
            }
          }
          this.timer = setTimeout(function () {
            self.render();
          }, 30);
        };
        LogBackground.prototype.drawCircle = function (ctx, x, y, r) {
          const self = this;
          function Circle(centerX, centerY, radius) {
            this.centerX = centerX;
            this.centerY = centerY;
            this.radius = radius;
          }
          const circle = new Circle(x, y, r);
          ctx.beginPath();
          ctx.arc(
            circle.centerX,
            circle.centerY,
            circle.radius,
            0,
            Math.PI * 2,
            true
          );
          ctx.fillStyle = self.options.circleColor;
          ctx.fill();
          ctx.closePath();
          return circle;
        };

        // 初始化
        new LogBackground({
          canvasContainerID: "canvas-background", // 运用背景的盒子的ID名，默认为“canvas-container”
          canvasOpacity: 1, // canvas背景的透明度，默认为0.8
          circleNum: 25, // 页面中随机产生的圆点的数量，默认为40
          circleColor: "rgba(43,135,209,1)", // 圆点的颜色，可接受rgb、rgba、十六进制、关键字形式，默认为rgba(180,180,180,1)
          lineColor: "rgba(43,135,209,1)", // 线条的颜色，只接受rgba形式，默认为rgba(180,180,180,1)
          circleMovemaxX: 1, // 圆点每次X轴移动最大的距离，整数为向右移动，负数为向左移动，默认为2
          circleMoveminX: -1, // 圆点每次X轴移动最小的距离，整数为向右移动，负数为向左移动，默认为-2
          circleMovemaxY: 1, // 圆点每次Y轴移动最大的距离，整数为向下移动，负数为向上移动，默认为2
          circleMoveminY: -1, // 圆点每次Y轴移动最小的距离，整数为向下移动，负数为向上移动，默认为-2
          // canvasWidth: 100, // canvas背景的宽度，默认为整个窗口可视区宽度
          // canvasHeight: 100, // canvas背景的高度，默认为整个窗口可视区高度
        });
      })();

      // setTimeout(this.resizeToFit, 0);
    },
  },
};
</script>

<style lang="scss">
.container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.body-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: 1;

  h2 {
    text-align: center;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    color: #020d1d;
    margin: 0 0 40px 0;
  }

  .box {
    box-shadow: 0 6px 20px 5px rgba(40, 120, 255, 0.1),
      0 16px 24px 2px rgba(0, 0, 0, 0.05);
    background: #fff;
    border-radius: 8px;
    width: 480px;
    padding: 50px 60px;
    box-sizing: border-box;
    position: relative;

    .form-btn {
      width: 100%;
    }
    .send-btn {
      position: absolute;
      right: 0;
      text-align: center;
      width: 120px;
      border: 1px solid #1b60c6;
      border-radius: 2px;
      .el-button--text {
        color: #1b60cb;
        border: unset;
        &.is-disabled {
          color: #bfcbd9;
        }
      }
      &.disabled {
        border-color: #bfcbd9;
      }
    }
    .el-form-item__content {
      line-height: unset;
    }
  }
}
@media (max-width: 768px) {
  .container {
    background: rgb(14, 80, 177);
  }
}
</style>
